module.exports = __webpack_public_path__ + "img/TNFF2.c792ea11.png";